import { render, staticRenderFns } from "./SecctionFormStyled.vue?vue&type=template&id=07147fe8&scoped=true&"
import script from "./SecctionFormStyled.vue?vue&type=script&lang=js&"
export * from "./SecctionFormStyled.vue?vue&type=script&lang=js&"
import style0 from "./SecctionFormStyled.vue?vue&type=style&index=0&id=07147fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07147fe8",
  null
  
)

export default component.exports